import { Component, OnInit } from '@angular/core';
import { ComplexInfoService } from '../../services/complex-info-service';
import { ComplexInfo } from '../../models/complex-info';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { uploadService } from '../../../../shared/uploadService';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FileVm } from '../../../../shared/Models/fileVm';

@Component({
  selector: 'app-create-complex-info',
  templateUrl: './create-complex-info.component.html',
  styleUrls: ['./create-complex-info.component.scss'],
})
export class CreateComplexInfoComponent implements OnInit {
  model = {} as ComplexInfo;
  isEdit = false;
  attachments: FormData;
  attachment: FileVm[] = [];
  isLoading: boolean = false;
  constructor(
    private service: ComplexInfoService,
    private diagRef: NbDialogRef<CreateComplexInfoComponent>,
    private toast: NbToastrService,
    private uploadService: uploadService,
    private route: Router
  ) { }

  ngOnInit() {
    this.route.events.subscribe(() => {
      this.diagRef.close('false');
    });
    if (!this.isEdit) {
      this.model = {} as ComplexInfo;
      this.model.privacyAR = '';
      this.model.privacyEN = '';
      this.model.termsAndConditionsAR = '';
      this.model.termsAndConditionsEN = '';
      // this.uploadService.updateFiles({ files: [], previousAttachments: [] });

    }
    else
    {
       this.attachment.push({
         fileName: this.model.hierarchy,
         type: '',
         path: '',
         tableName: '',
         id: 0,
         refId: 0,
         originalFileName: ''
       });
    }
  }

  save() {
    this.isLoading = true;
    this.uploadService
      .uploadMultipleFiles()
      .pipe(
        switchMap((res) => {
          this.model.hierarchy = res[0].fileName;
          return this.isEdit ? this.service.put(this.model.id, this.model) : this.service.post(this.model);
        })
      )
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.isEdit
            ? this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 })
            : this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
        },
        (err) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.isEdit
            ? this.toast.danger('خطأ في التعديل', '', { status: 'success', duration: 3000 })
            : this.toast.danger('خطأ في الحفظ', '', { status: 'success', duration: 3000 });
        }
      );
    // this.service.post(this.model).subscribe((res) => {
    //   this.diagRef.close('true');
    //   this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
    // });
  }

  update() {
    this.isLoading = true;
    if (!this.attachments) 
       return this.service.put(this.model.id, this.model) .subscribe(
        (res) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.isEdit
            ? this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 })
            : this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
        },
        (err) => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.isEdit
            ? this.toast.danger('خطأ في التعديل', '', { status: 'success', duration: 3000 })
            : this.toast.danger('خطأ في الحفظ', '', { status: 'success', duration: 3000 });
        }
      );
      
    this.uploadService
      .uploadMultipleFiles()
      .pipe(
        switchMap((res) => {
                if (res && res.length > 0) {

          if (res[0].fileName && res[0].fileName.length > 0) {
            const fileType = this.uploadService.SelectFileType(res[0].fileName);
            if (fileType === 'photo') {
              this.model.hierarchy = res[0].fileName;
            }
            else {
              this.toast.danger(' برجاء اختيار صورة للهيكل التنظيمي ', '', { status: 'success', duration: 3000 })
              return;
            }
          }
        }

          return this.service.put(this.model.id, this.model);
        })
      )
      .subscribe((res) => {
        this.isLoading = false;
        this.diagRef.close('true');
        this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 });
      });
  }

  close() {
    this.diagRef.close();
  }

  uploadFile(evt: any) {
    this.attachments = new FormData();
    for (let file of evt.files) {
      this.attachments.append(file.name, file);
    }
  }
}
